const subheadingsData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
          <p>
            I'm Hedi, a very passionate developer driven by a love for coding
            and creating innovative solutions. With expertise in web development
            and a keen interest in game development and AI, I constantly push
            the boundaries of what's possible through code. Collaboration and
            lifelong learning fuel my drive to make a meaningful impact in the
            digital world.
          </p>
        </>
      ),
    },
  ],
  2: [
    {
      title: "2023 Bachelors Degree",
      content: (
        <>
          <p>
            By diligently pursuing my studies in embedded systems and internet
            of things, I am poised to achieve my long-awaited goal of obtaining
            a bachelor's degree in this field by the year 2023. With a deep
            passion for cutting-edge technology and a relentless commitment to
            learning, I have embraced the challenges and triumphs of my academic
            journey, equipping myself with a comprehensive understanding of
            hardware, software, and their integration.
          </p>
        </>
      ),
    },
    {
      title: "2019 High School Diploma",
      content: (
        <>
          <p>
            Through unwavering dedication and a thirst for knowledge, I
            successfully attained my High School Diploma in Science and
            Technology in the year 2019. With an insatiable curiosity for
            scientific exploration and a passion for technological advancements,
            I eagerly embraced the challenges presented by the curriculum.
          </p>
        </>
      ),
    },
  ],
  3: [
    {
      title: "2023 Game Developer intern",
      content: (
        <>
          <p>
            Having completed a dynamic and immersive 4-month internship at a
            mobile game development company, I am exhilarated by the invaluable
            experience and skills gained during my time there. Working alongside
            talented professionals in a fast-paced environment, I actively
            contributed to the creation and optimization of an educational and
            entertaining mobile game.
          </p>
        </>
      ),
    },
    {
      title: "2022 Network Technician intern",
      content: (
        <>
          <p>
            Having successfully completed a one-month internship as a network
            technician at a prestigious 5-star hotel, I am thrilled to have
            gained invaluable hands-on experience in the field. Throughout my
            internship, I meticulously maintained and troubleshooted the hotel's
            network infrastructure, ensuring seamless connectivity for guests
            and staff.
          </p>
        </>
      ),
    },
  ],
};

export default subheadingsData;
